import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Progress from 'components/Misc/Progress';
import Nothing from 'components/Misc/Nothing';
import Container from 'components/Misc/Container';

import Grade from 'containers/Administrator/Programs/Profile/Grades/Grade';

const Grades = ({ tab, setTab }) => {
	// Cache current program's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: 'students',
		programId: id
	}), [id]);

	// Store requested grades
	const [[grades, progress], collect] = useCollect('grades', parameters);

	// Collect exam on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// TODO: Remove after test
	useEffect(() => console.log('PROGRAM.GRADES:', grades), [grades]);

	return (
		<>
			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Show nothing found */}
			<Nothing visible={!grades?.length && !progress} />

			{/* Show collection if results collected */}
			<Show if={grades?.length && !progress}>
				<Container className="mt-4 flex flex-col transition-all">
					{grades?.map(grade =>
						<Grade key={grade.id} grade={grade} />
					)}
				</Container>
			</Show>
		</>
	);
};

export default Grades;
